import { ConversationMembersData } from "@virtualprogaming/js-public-sdk";
import { map } from "lodash";
import React, { FC, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";

import {
  useChatConversationRemoveMembers,
  useChatSystemConversationRemoveMembers,
} from "~/queries";
import { Icon, LoadingIcon } from "~/ui/components/icons";
import {
  useChatAuthAccessToken,
  useChatAuthUserData,
  useChatSettings,
} from "~/ui/context";

export const CurrentMembers: FC<{
  members: ConversationMembersData[];
  onClose: () => void;
  chatId: number;
  isGlobal: boolean;
  isConversationAdmin: boolean;
  shouldNotShowRemove: boolean;
}> = ({
  members,
  onClose,
  chatId,
  isGlobal = false,
  isConversationAdmin = false,
  shouldNotShowRemove = false,
}) => {
  const { push } = useHistory();
  const accessToken = useChatAuthAccessToken();
  const { chatAuthUser } = useChatAuthUserData();
  const { setIsChatOpen } = useChatSettings();
  const [memberToRemove, setMemberToRemove] = useState<number | null>(null);
  const {
    mutateAsync: removeMember,
    isLoading: isRemoveMemberLoading,
  } = useChatConversationRemoveMembers();
  const {
    mutateAsync: removeMemberSystem,
    isLoading: isRemoveMemberLoadingSystem,
  } = useChatSystemConversationRemoveMembers();

  const handleMemberRemove = (id: number | undefined) => {
    if (!id) return;
    if (isGlobal && !isConversationAdmin) return;
    setMemberToRemove(id);
    if (isGlobal && isConversationAdmin) {
      removeMemberSystem([chatId, [id]]).then(() => setMemberToRemove(null));
    } else {
      removeMember([chatId, accessToken, [id]]).then(() =>
        setMemberToRemove(null)
      );
    }
  };

  const openProfile = (member: ConversationMembersData) => {
    push(`/user/${member.display_name}`);
    setIsChatOpen(false);
  };

  return (
    <div className="flex flex-col borderR-05">
      <div className="flex items-center justify-between pd-r-sm pd-l-md pd-b-xs mg-b-sm border-bottom">
        <h6 className="font-variant-small-caps">
          <FormattedMessage defaultMessage="Current members" id="/R4idx" />
        </h6>
        <Icon
          onClick={onClose}
          icon={["fal", "times"]}
          size="lg"
          className="pd-t-sm pointer"
        />
      </div>
      <div className="h-max-300px scroll-auto scroll-hide pd-b-sm">
        {map(
          members,
          (member: ConversationMembersData) =>
            chatAuthUser?.user?.id !== member.id && (
              <div
                className="flex items-center justify-between hover-light borderR-05 pointer"
                key={member.id}
                onClick={() =>
                  shouldNotShowRemove
                    ? openProfile(member)
                    : handleMemberRemove(member.id)
                }
              >
                <p className="mg-l-md">{member.display_name}</p>
                {shouldNotShowRemove ? null : (isRemoveMemberLoading ||
                    isRemoveMemberLoadingSystem) &&
                  memberToRemove === member.id ? (
                  <LoadingIcon size="lg" className="mg-r-md" />
                ) : (
                  <Icon
                    icon={["far", "user-minus"]}
                    size="lg"
                    className="mg-r-sm pointer"
                  />
                )}
              </div>
            )
        )}
      </div>
    </div>
  );
};
